module.exports = __webpack_public_path__ + "media/src/images/avatar_placeholder-47715aa9800027454c122830711e3f4f.png";